import styles from './AddNewButton.module.css';

function AddNewButton({ text, onClick, disabled }) {
  return (
    <button className={styles.addNewButton} onClick={onClick} disabled={disabled}>
      {text}
    </button>
  );
}
export default AddNewButton;    